const formControlLabelModalSupportFiles = {
  all: 'Todos',
  internal: 'Internos',
  external: 'Contratados'
};

export default formControlLabelModalSupportFiles;
